import React, { Component } from 'react'

import style from './style.css'

export default class LoaderRounded extends Component {

  render() {
    return (
        <div style={{
            width: this.props.size || '100px',
            height: this.props.size || '100px',
        }}>
            <svg className={`${style.progress} ${this.props.animate ? style.animate : ''}`} viewBox="0 0 33.8 33.8">
                <circle style={{
                    strokeWidth: this.props.stroke || '2'
                }} className={style.bg} r="15.9" cx="16.9" cy="16.9" />
                <circle style={{
                    strokeWidth: this.props.stroke || '2'
                }} className={style.loader} strokeDasharray={`${this.props.progress}, 100`} r="15.9" cx="16.9" cy="16.9" />
            </svg>
        </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/atoms/LoaderRounded/index.js